import {
  Component,
  OnInit,
  ViewEncapsulation,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { ENFTReportService } from "./enftreport.service";
import {
  IMultiSelectOption,
  IMultiSelectSettings,
  IMultiSelectTexts,
} from "angular-2-dropdown-multiselect";
import { IMyDpOptions } from "mydatepicker";
import * as moment from "moment";

@Component({
  moduleId: module.id,
  templateUrl: "enftreport.html",
  styleUrls: ["enftreport.component.css"],
})
export class ENFTReportComponent implements OnInit {
  topScrollWidth: number = 2500;
  dataLoaded: boolean;
  public loading = false;
  selectedYear: string[];
  //selectedHireMonth: string[];
  selectedHireMonth: string;
  selectedControlGroup: string[];
  selectedTypeOfHours: any;
  selectedNonFullTimeCatgeories: string[];
  selectedAvgWeeklyHrsThr: any[];
  selectedweekCount: number;
  downloadPdfInProgress: boolean = false;
  downloadExcelInProgress: boolean = false;
  NonFullTimeCatgeories: Array<string>;
  errorMessage: string;
  count13Weeks: string;
  count26Weeks: string;
  count47Weeks: string;
  count52Weeks: string;

  optionsModel: number[];
  myOptions: any = [];
  myYearOptions: IMultiSelectOption[];
  myMonthOptions: IMultiSelectOption[];
  mySettings: IMultiSelectSettings = {
    enableSearch: false,
    showCheckAll: true,
    showUncheckAll: true,
    checkedStyle: "checkboxes",
    buttonClasses: "btn btn-default btn-block",
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: true,
  };
  // Options for the select dropdown
  reportedHours = [
    { id: 1, name: "All", value:"%27%27" },
    { id: 2, name: "Non Union", value: "NON UNION" },
    { id: 3, name: "Union", value: "UNION" },
  ]
  AvgWeeklyHrs = [
    { id: 1, name: "Any", value:"%27%27" },
    { id: 2, name: ">=30", value: ">=30" },
    { id: 3, name: "<30", value: "<30" },
  ]
  periodHours = [
    { id: 3, name: "3 Months" },
    { id: 4, name: "4 Months" },
    { id: 5, name: "5 Months" },
    { id: 6, name: "6 Months" },
    { id: 7, name: "7 Months" },
    { id: 8, name: "8 Months" },
    { id: 9, name: "9 Months" },
    { id: 10, name: "10 Months" },
    { id: 11, name: "11 Months" },
  ];
  // Property for the selected value, defaulting to the first option
  selectedPeriodHours: any[];
  myYearSettings: IMultiSelectSettings = {
    enableSearch: false,
    showCheckAll: true,
    showUncheckAll: true,
    checkedStyle: "checkboxes",
    buttonClasses: "btn btn-default btn-block",
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: true,
  };

  myMonthSettings: IMultiSelectSettings = {
    enableSearch: false,
    showCheckAll: true,
    showUncheckAll: true,
    checkedStyle: "checkboxes",
    buttonClasses: "btn btn-default btn-block",
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: true,
  };

  //  Text configuration
  myTexts: IMultiSelectTexts = {
    checkAll: "Select all",
    uncheckAll: "Unselect all",
  };
  myYearTexts: IMultiSelectTexts = {
    checkAll: "Select all",
    uncheckAll: "Unselect all",
  };

  myTextTexts: IMultiSelectTexts = {
    checkAll: "Select all",
    uncheckAll: "Unselect all",
  };

  workDetails: Array<any> = [];

  nonFullTimeOptions: any[];
  nonFullTimeSettings = {
    singleSelection: false,
    text: "Select Categories",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    enableSearchFilter: true,
    classes: "myclass custom-class categories-dropdown",
    badgeShowLimit: 3,
  };

  //  Text configuration
  nonFullTimeTexts: IMultiSelectTexts = {
    checkAll: "Select all",
    uncheckAll: "Unselect all",
  };
  @ViewChild("topScroll") topScroll: ElementRef;
  @ViewChild("bottomScroll") bottomScroll: ElementRef;
  bydefaultToast: boolean= true;
  public rows: Array<any> = [];
  public columns: Array<any> = [
    { title: "IMP End Date", className: "va-m", name: "impEndDate" },
    { title: "Controlled Group", className: "va-m", name: "controlGroup" },
    { title: "Latest Production Company", className: "va-m", name: "mostRecentProductionCompany"},
    { title: "Most Recent Show", className: "va-m", name: "mostRecentProject" },
    { title: "SSN", className: "hidden-xs va-m", name: "ssnNumber" },
    { title: "First Name", className: "hidden-xs va-m", name: "firstName" },
    { title: "Last Name", className: "va-m", name: "lastName" },
    { title: "Email Id", className: "va-m", name: "emailId" },
    { title: "Hire Date", className: "va-m", name: "hireDate" },
    { title: "New Hire Date", className: "va-m", name: "newHireDate" },
    { title: "Last Worked Date", className: "va-m", name: "lastWorkedDate" },
    { title: "ACA Employment Status", className: "va-m", name: "actualAcaEmploymentStatus"},
    { title: "Union Status", className: "va-m", name: "unionType" },
    { title: "Union Name", className: "va-m", name: "unionName" },
    { title: "Payroll Source", className: "va-m", name: "payrollSource" },
    { title: "Average Hours", className: "va-m", name: "avgHours" },
    { title: "Total Hours", className: "va-m", name: "totalHours" },
    { title: "Employee Type", className: "va-m", name: "employeeType" },
    { title: "Date Of Birth", className: "va-m", name: "dateOfBirth" },
    { title: "Rate Of Pay Unit", className: "va-m", name: "rateOfPayUnit" },
    { title: "Resident Address1", className: "va-m", name: "address1" },
    { title: "Resident Address2", className: "va-m", name: "address2" },
    { title: "City", className: "va-m", name: "residentCity" },
    { title: "State", className: "va-m", name: "residentState" },
    { title: "Country", className: "va-m", name: "residentCountry" },
    { title: "Zipcode", className: "va-m", name: "residentZip" },
    { title: "Employee ID", className: "va-m", name: "employeeId" },
    { title: "Pay Cycle", className: "va-m", name: "payCycle" },
    { title: "Employee Status", className: "va-m", name: "employeeStatus" },
  ];
  public page = 1;
  public itemsPerPage = 10;
  public maxSize = 5;
  public numPages = 1;
  public length = 0;

  public config: any = {
    paging: true,
    sorting: { columns: this.columns },
    filtering: { filterString: "" },
    className: ["table", "table-striped", "table-bordered", "table-hover"],
  };
  userData: any;
  cgDropdownSettings = {};
  selectedCgValues: any[];
  downloadexcel: any;
  downloadpdf: any;
  selectedCategoriesValues: any[];
  showDateError: boolean = false;
  isfilterloaded: boolean = false;
  public myStartDatePickerOptions: IMyDpOptions = {};
  selectedDate: any = {};
  selectedPeriodToast: boolean = false;
  constructor(private _enftreport: ENFTReportService) {
    this.userData = JSON.parse(localStorage.getItem("token"));
  }

  ngOnInit(): void {
    this.setFilterData();
    this.cgDropdownSettings = {
      singleSelection: false,
      text: "Select Controlled Group",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "myclass custom-class controlled-group-dropdown",
      badgeShowLimit: 3,
    };
    if (localStorage.getItem("storedData")) {
      this.onloadData();
    }

    this.onChangeTable(this.config);
    // this.reset();
    this.selectedDate = "";
  }
  onloadData(): void {
    const ssnData = JSON.parse(localStorage.getItem("storedData"));
    this.loading = true;
    this._enftreport.getSSnData(ssnData).subscribe(
      (workdetails) => {
        this.loading = false;
        this.workDetails = workdetails;
        this.onChangeTable(this.config);
        this.dataLoaded = true;
        // this.topScrollWidth = this.bottomScroll.nativeElement.scrollWidth;
      },
      (error) => (this.errorMessage = <any>error)
    );
  }
  // Method to handle the change event
  onSelectChange(event: any): void {
    if(event.target.length){
      this.bydefaultToast = false;
      this.selectedPeriodToast = true;
    }
    

    // Add any additional logic you need here
  }

  reset(): void {
    this.selectedYear = [];
    //this.selectedHireMonth = [];
    this.selectedHireMonth = "";
    this.selectedTypeOfHours = undefined;
    this.selectedNonFullTimeCatgeories = [];
    this.count13Weeks = "0";
    this.count26Weeks = "0";
    this.count47Weeks = "0";
    this.count52Weeks = "0";
    this.dataLoaded = false;
    this.selectedweekCount = 13;
    this.selectedCategoriesValues = undefined;
    this.showDateError = false;
    if (
      this.userData.principal.roles[0] !== "User" ||
      this.userData.principal.controlGroups.length > 1
    ) {
      this.selectedControlGroup = [];
      this.selectedCgValues = [];
    }
    this.selectedDate = "";
    this.selectedPeriodHours = undefined;
    this.selectedAvgWeeklyHrsThr = undefined;
    this.selectedPeriodToast = false;
    this.bydefaultToast = true;
  }

  getTableData() {
   
    let filterCriteria = {
      selectedDate: this.selectedDate ? moment(new Date(this.selectedDate.date.year,this.selectedDate.date.month - 1, this.selectedDate.date.day)).format("YYYY-MM-DD"): '\'\'',
      ControlGroup: this.selectedCgValues ? this.selectedCgValues.map((item: any) => item.itemName).join(":"): '\'\'',
      UnionType: this.selectedTypeOfHours ? this.selectedTypeOfHours : '\'\'',
      EmployeeType: this.selectedCategoriesValues ? this.selectedCategoriesValues.map((item: any) => item.itemName) : '\'\'',
      AvgWeeklyThreshold: this.selectedAvgWeeklyHrsThr ? this.selectedAvgWeeklyHrsThr : '\'\'',
      lookbackPeriod: this.selectedPeriodHours ? this.selectedPeriodHours : '\'\'',
    };
    if (
      !filterCriteria.selectedDate ||
      !filterCriteria.ControlGroup ||
      !this.selectedPeriodHours
    ) {
      this.showDateError = true;
      return;
    }
    this.showDateError = false;
    this.loading = true;
    this.dataLoaded = false;
    this._enftreport.getWeeklyCounts(filterCriteria).subscribe(
      (data: any) => {
        this.loading = false;
        this.dataLoaded = true;
        this.workDetails = data.reportByWeekCount;
        this.onChangeTable(this.config);
      },
      (error: any) => {
        this.errorMessage = error;
        this.dataLoaded = false;
        this.loading = false;
        this.showDateError = false;
      }
    );
  }
  // Search(): void {
  //   this.page = 1;
  //   this.showDateError = false;
  //   const filterCriteria = this.getFilterValues();
  //   this.count13Weeks = "0";
  //   this.count26Weeks = "0";
  //   this.count47Weeks = "0";
  //   this.count52Weeks = "0";
  //   if (
  //     filterCriteria.selectedHireMonth.length === 2 ||
  //     filterCriteria.selectedControlGroup.length === 2
  //   ) {
  //     this.showDateError = true;
  //     return;
  //   }
  //   this.isfilterloaded = true;
  //   this.loading = true;
  //   this._enftreport.getWeeklyCounts(filterCriteria).subscribe(
  //     (counts) => {
  //       if (
  //         counts === undefined ||
  //         counts == null ||
  //         (counts != null && counts.reportCountByWeek == null)
  //       ) {
  //         return;
  //       }
  //       counts.reportCountByWeek.forEach((element: any) => {
  //         switch (element.WEEKS_WORKED) {
  //           case "13":
  //             this.count13Weeks = element.WEEKS_WORKED_COUNT;
  //             break;
  //           case "26":
  //             this.count26Weeks = element.WEEKS_WORKED_COUNT;
  //             break;
  //           case "47":
  //             this.count47Weeks = element.WEEKS_WORKED_COUNT;
  //             break;
  //           case "52":
  //             this.count52Weeks = element.WEEKS_WORKED_COUNT;
  //             break;
  //         }
  //       });
  //       this.getWeekData(11);
  //       this.isfilterloaded = false;
  //       this.loading = false;
  //     },
  //     (error: any) => (this.errorMessage = <any>error)
  //   );
  // }

  // getWeekData(weekCount: number): void {
  //   this.selectedweekCount = weekCount;
  //   const filterCriteria = this.getFilterValues();
  //   filterCriteria.reportCount = this.selectedweekCount;
  //   this._enftreport.getWeekReportData(filterCriteria).subscribe(
  //     (workdetails) => {
  //       this.loading = false;
  //       this.workDetails = workdetails;
  //       this.onChangeTable(this.config);
  //       this.dataLoaded = true;
  //       // this.topScrollWidth = this.bottomScroll.nativeElement.scrollWidth+100;
  //     },
  //     (error) => (this.errorMessage = <any>error)
  //   );
  // }


  downloadExcel(): void {
    this.downloadexcel = true;
    let filterCriteria = {
      selectedDate: this.selectedDate ? moment(new Date(this.selectedDate.date.year,this.selectedDate.date.month - 1, this.selectedDate.date.day)).format("YYYY-MM-DD"): '\'\'',
      ControlGroup: this.selectedCgValues ? this.selectedCgValues.map((item: any) => item.itemName).join(":"): '\'\'',
      UnionType: this.selectedTypeOfHours ? this.selectedTypeOfHours : '\'\'',
      EmployeeType: this.selectedCategoriesValues ? this.selectedCategoriesValues.map((item: any) => item.itemName) : '\'\'',
      AvgWeeklyThreshold: this.selectedAvgWeeklyHrsThr ? this.selectedAvgWeeklyHrsThr : '\'\'',
      lookbackPeriod: this.selectedPeriodHours ? this.selectedPeriodHours : '\'\'',
    };
    this._enftreport.downloadExcelReport(filterCriteria).subscribe(
      (data: any) => {
        this.downloadexcel = false;
      },
      (err: any) => (this.downloadexcel = false)
    );
  }
  public onCellClick(data: any): any {
    console.log(data);
  }

  public changePage(
    page: any,
    data: Array<any> = this.workDetails
  ): Array<any> {
    const start = (page.page - 1) * page.itemsPerPage;
    const end =
      page.itemsPerPage > -1 ? start + page.itemsPerPage : data.length;
    return data.slice(start, end);
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString, "i");
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(
          new RegExp(this.config.filtering.filterString, "i")
        )
      );
    }

    const tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (item[column.name] == null) {
          item[column.name] = "";
        }
      });
      this.columns.forEach((column: any) => {
        if (
          item[column.name]
            .toLowerCase()
            .match(new RegExp(this.config.filtering.filterString, "i"))
        ) {
          flag = true;
        } else if (
          item[column.name]
            .toUpperCase()
            .match(new RegExp(this.config.filtering.filterString, "i"))
        ) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    const columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== "" && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === "desc" ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === "asc" ? -1 : 1;
      }
      return 0;
    });
  }
  public onChangeTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    const filteredData = this.changeFilter(this.workDetails, this.config);
    const sortedData = this.changeSort(filteredData, this.config);
    this.rows =
      page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }
  arescrolling = 0;
  scroller(from: any, to: any) {
    if (this.arescrolling) return; // avoid potential recursion/inefficiency
    this.arescrolling = 1;
    from.scrollLeft = to.scrollLeft;
    this.arescrolling = 0;
  }
  ngOnDestroy() {
    localStorage.removeItem("storedData");
  }

  onChangeControlledGroup() {
    this.selectedControlGroup = this.selectedCgValues
      ? this.selectedCgValues.map((item: any) => item.itemName)
      : [];
  }

  onChangeCategories() {
    this.selectedNonFullTimeCatgeories = this.selectedCategoriesValues
      ? this.selectedCategoriesValues.map((item: any) => item.itemName)
      : [];
  }

  dateHandler(event: any) {
    this.showDateError =
      event.length === 2 || !this.selectedCgValues.length ? true : false;
  }

  setFilterData() {
    this.myYearOptions = [];
    this.myMonthOptions = [];
    this.myOptions = [];
    this.nonFullTimeOptions = [];
    this._enftreport.getReportData().subscribe(
      (data) => {
        this.NonFullTimeCatgeories = data.EmployeeType;
        this.myYearOptions = data.WorkYear.map((element: any) => {
          return { id: element, name: element };
        });
        this.myMonthOptions = data.WorkMonth.map((element: any) => {
          return { id: element, name: element };
        });
        this.nonFullTimeOptions = data.EmployeeType.map((element: any) => {
          return { id: element, itemName: element };
        });

        
        if (this.userData.principal.roles[0] == "User") {
          if (this.userData.principal.controlGroups.length == 1) {
            this.cgDropdownSettings["disabled"] = true;
            this.cgDropdownSettings["singleSelection"] = true;
            this.cgDropdownSettings = Object.assign(
              {},
              this.cgDropdownSettings
            );
            this.selectedCgValues = [
              {
                id: this.userData.principal.controlGroups[0],
                itemName: this.userData.principal.controlGroups[0],
              },
            ];
            this.selectedControlGroup = [
              this.userData.principal.controlGroups[0],
            ];
          } else {
            this.myOptions = this.userData.principal.controlGroups
              .filter((val: any) => data.ControlGroup.includes(val))
              .map((element: any) => {
                return { id: element, itemName: element };
              });
          }
        } else {
          this.myOptions = data.ControlGroup.map((element: any) => {
            return { id: element, itemName: element };
          });
        }
        // this.AvgWeeklyHrs.push('>30')
        // this.AvgWeeklyHrs.push('<30')
      },
      (error) => (this.errorMessage = <any>error)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/enftreport/enftreport.component.ts